import { render, staticRenderFns } from "./panoramicMarker.vue?vue&type=template&id=60f6f046&"
import script from "./panoramicMarker.vue?vue&type=script&lang=js&"
export * from "./panoramicMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports